export default {
  'art.metaTitle': 'Poradnik dla początkujących USFans Spreadsheet: Jak badać i kupować mądrzej',
  'art.metaDescription':
    'Nowy w USFans? Ten poradnik dla początkujących wyjaśnia USFans Spreadsheet, jak przeglądać kategorie, czytać zdjęcia QC, szacować wysyłkę i bezpiecznie używać kuponów.',

  'art.breadcrumbHome': 'Strona główna',
  'art.breadcrumbGuides': 'Poradniki',
  'art.breadcrumbCurrent': 'Poradnik dla początkujących',

  'art.title': 'Poradnik dla początkujących USFans Spreadsheet',
  'art.subtitle': 'Jak badać produkty, czytać zdjęcia QC i kupować z pewnością',
  'art.writtenBy': 'Napisane przez zespół redakcyjny USFans',
  'art.reviewedBy': 'Zweryfikowane przez zespół redakcyjny USFans',
  'art.updated': 'Ostatnia aktualizacja',

  'art.intro':
    'Zaczynanie z USFans może wydawać się przytłaczające. Są linki produktów do otwarcia, zdjęcia QC do sprawdzenia, opcje wysyłki do zrozumienia i szczegóły magazynu do rozważenia. Ten poradnik prowadzi Cię przez USFans Spreadsheet krok po kroku, abyś mógł badać produkty, rozumieć kontrolę jakości i podejmować świadome decyzje przed zakupem.',

  'art.h1': 'Czym jest USFans Spreadsheet?',
  'art.p1a':
    'USFans Spreadsheet to uporządkowane źródło, które łączy linki produktów, kategorie i informacje zakupowe w jednym przeszukiwalnym miejscu. Zamiast przewijać rozproszone posty czy wiadomości, możesz przeglądać według kategorii i szybciej znajdować odpowiednie przedmioty.',
  'art.p1b':
    'To narzędzie badawcze, a nie oficjalny sklep. Zawsze otwieraj linki, przeglądaj szczegóły na głównej stronie i wykonuj własne kontrole przed sfinalizowaniem zakupu.',

  'art.h2': 'Jak działa USFans Spreadsheet',
  'art.p2a': 'Pomysł jest prosty: przeglądaj kategorię, otwórz link produktu, porównaj opcje, a potem zdecyduj.',
  'art.l21': 'Przeglądaj kategorie takie jak Buty, Bluzy, Koszulki, Kurtki i inne.',
  'art.l22': 'Otwórz link produktu, aby zobaczyć pełne szczegóły na głównej stronie.',
  'art.l23': 'Porównaj podobne przedmioty przed podjęciem decyzji.',
  'art.l24': 'Korzystaj z poradników, aby zrozumieć QC, wysyłkę i kupony.',

  'art.h3': 'Zrozumienie głównych kategorii',
  'art.p3a':
    'Spreadsheet jest podzielony na jasne kategorie, abyś szybciej znalazł to, czego potrzebujesz: Buty, Bluzy/Swetry, Koszulki, Kurtki, Spodnie/Szorty, Nakrycia głowy, Zestawy, Bielizna, Koszulki sportowe, Akcesoria, Torby, Paski, Perfumy i Inne rzeczy.',
  'art.p3b':
    'Zacznij od kategorii odpowiadającej temu, czego szukasz, a następnie przejrzyj kilka przedmiotów przed zawężeniem wyboru.',

  'art.h4': 'Jak czytać zdjęcia QC',
  'art.p4a':
    'Zdjęcia QC (kontrola jakości) to zdjęcia rzeczywistego przedmiotu przed wysyłką. Pomagają zobaczyć, co naprawdę otrzymujesz.',
  'art.l41': 'Dokładnie sprawdź szwy i umiejscowienie logo.',
  'art.l42': 'Porównaj kolory i szczegóły z listą produktu.',
  'art.l43': 'Sprawdź wymiary, jeśli są podane.',
  'art.l44': 'Poproś o więcej zdjęć, jeśli coś jest niejasne.',

  'art.h5': 'Koszty wysyłki i co na nie wpływa',
  'art.p5a':
    'Wysyłka może zmienić końcowy koszt zamówienia. Zależy od miejsca docelowego, wagi paczki, objętości, linii wysyłkowej, opakowania, ubezpieczenia, a nawet sezonu.',
  'art.p5b':
    'Ceny się różnią, więc zawsze sprawdzaj aktualne stawki i szacuj przed zakupem, zamiast zakładać stałą kwotę.',

  'art.h6': 'Kupony i kody rabatowe',
  'art.p6a':
    'Kupony i kody rabatowe mogą pomóc Ci zaoszczędzić, ale kody często się zmieniają. Zawsze sprawdzaj aktualny status, datę wygaśnięcia i ograniczenia przed użyciem. Jeśli nie ma zweryfikowanego aktywnego kodu, traktuj regularną cenę jako punkt odniesienia.',

  'art.h7': 'Czy USFans jest bezpieczne? Co sprawdzić',
  'art.l71': 'Weryfikuj linki przed ich otwarciem.',
  'art.l72': 'Dokładnie sprawdzaj informacje o sprzedawcy.',
  'art.l73': 'Chroń swoje konto i dane płatności.',
  'art.l74': 'Przeglądaj warunki wysyłki i zwrotów.',
  'art.l75': 'Bądź ostrożny przy podejrzanych lub zbyt dobrych ofertach.',

  'art.h8': 'Lista kontrolna dla początkujących',
  'art.l81': 'Zdecyduj, którą kategorię chcesz przeglądać.',
  'art.l82': 'Otwórz i przejrzyj kilka linków produktów.',
  'art.l83': 'Sprawdź zdjęcia QC i wymiary.',
  'art.l84': 'Oszacuj wysyłkę przed zakupem.',
  'art.l85': 'Poszukaj aktualnego kuponu lub zniżki.',
  'art.l86': 'Potwierdź dane sprzedawcy i płatności.',
  'art.l87': 'Przeglądaj zasady zwrotów i refundacji.',
  'art.l88': 'Zachowaj zapisy zamówienia.',

  'art.faqQ1': 'Czy potrzebuję konta, aby przeglądać USFans Spreadsheet?',
  'art.faqA1':
    'Przeglądanie kategorii i linków nie wymaga konta. Zakupy i funkcje związane z kontem są obsługiwane na głównej stronie.',
  'art.faqQ2': 'Czy USFans Spreadsheet jest darmowy?',
  'art.faqA2':
    'Sam spreadsheet jest darmowym źródłem informacji. Poszczególne produkty mają własne ceny, które warto zweryfikować na głównej stronie.',
  'art.faqQ3': 'Jak często spreadsheet jest aktualizowany?',
  'art.faqA3':
    'Aktualizacje mogą się różnić. Zawsze sprawdzaj główną stronę, aby zobaczyć najnowsze oferty, ceny i dostępność.',
  'art.faqQ4': 'Czy mogę używać spreadsheetu na telefonie?',
  'art.faqA4': 'Tak, kategorie i linki są dostępne z dowolnego urządzenia z przeglądarką.',

  'art.conclusion':
    'USFans Spreadsheet to pomocny punkt wyjścia do badania produktów. Przeglądaj kategorie, otwieraj linki, sprawdzaj zdjęcia QC i szacuj wysyłkę, a następnie przejdź na główną stronę, aby sfinalizować zakup. Aby uzyskać więcej informacji, wróć na naszą stronę główną i poznaj poradniki, recenzje oraz zasoby wysyłkowe.',
  'art.ctaHome': 'Wróć na stronę główną',
  'art.ctaSpreadsheet': 'Odwiedź główną stronę',
};